import { useState, useEffect } from "react";
import { getQueryParam, updateQueryParam } from "shared/lib";
import { useDebouncedTableFilter } from "./useDebouncedTableFilter";

export const useUpdatedMaterialManagementsFilters = () => {
  const initialCategory = getQueryParam("materialCategory");

  const {
    debouncedValue: debouncedNameContains,
    handleFilterChange: handleNamedValue,
    value: nameValue,
    clearFilterValue: clearNameValue,
  } = useDebouncedTableFilter("name", 400);

  const [materialCategoryFilteringItem, setMaterialCategoryFilteringItem] =
    useState<number | string>(initialCategory || "");

  const handleMaterialCategory = (value: number | string) => {
    setMaterialCategoryFilteringItem(value);
    updateQueryParam("materialCategory", value as string);
  };

  const isVisibleClearFiltersButton =
    !!debouncedNameContains || !!materialCategoryFilteringItem;

  const clearMaterialCategoryFilter = () => {
    setMaterialCategoryFilteringItem("");
    updateQueryParam("materialCategory");
  };

  const clearAllFilters = () => {
    clearNameValue();
    clearMaterialCategoryFilter();
    updateQueryParam("name");
  };

  useEffect(() => {
    updateQueryParam("name", nameValue);
  }, [nameValue]);

  return {
    debouncedNameContains,
    handleNamedValue,
    nameValue,
    materialCategoryFilteringItem,
    setMaterialCategoryFilteringItem,
    clearAllFilters,
    isVisibleClearFiltersButton,
    clearNameValue,
    handleMaterialCategory,
  };
};
